<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Dashboard</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a routerLink="/main">Home</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>
<section class="content mycontent">
    <div class="container-fluid">

        <ng-container *ngIf="layoutEnabled == 'layout1'">
            <ng-container *ngTemplateOutlet="layout1"></ng-container>
        </ng-container>
        <ng-container *ngIf="layoutEnabled == 'layout2'">
            <ng-container *ngTemplateOutlet="layout2"></ng-container>
        </ng-container>
        <ng-container *ngIf="layoutEnabled == 'layout3'">
            <ng-container *ngTemplateOutlet="layout3"></ng-container>
        </ng-container>
        <ng-container *ngIf="layoutEnabled == 'layout4'">
            <ng-container *ngTemplateOutlet="layout4"></ng-container>
        </ng-container>
        <ng-container *ngIf="layoutEnabled == 'layout5'">
            <ng-container *ngTemplateOutlet="layout5"></ng-container>
        </ng-container>
        <ng-container *ngIf="layoutEnabled == 'layout6'">
            <ng-container *ngTemplateOutlet="layout6"></ng-container>
        </ng-container>

        <!-- Control Sidebar -->
        <aside class="control-sidebar control-sidebar-dark">

        </aside>
    </div>
</section>

<ng-template #layout1>
    <div class="col-md-12">

        <!-- /.content-header -->

        <!-- Main content -->

        <div class="container-fluid">
            <!-- Small boxes (Stat box) -->
            <div class="row">

                <div class="col-6 col-6">
                    <!-- small box -->
                    <div class="small-box bg-box-blue">
                        <div class="inner">
                            <div class="mt-3 ml-3">
                                <h3 style="font-size: 40px;">{{totalPatient}}</h3>

                                <p style="font-size: 20px;">Pazienti presi in carico</p>
                            </div>
                        </div>
                        <div class="icon mt-1 mr-1" style="color:white !important;">
                            <i class="fas fa-users"></i>
                        </div>
                        <a href="javascript:void(0)" (click)="goToListPatient()"
                            class="small-box-footer small-box-footer-blue">Vai alla lista <i
                                class="fa fa-arrow-circle-right"></i></a>
                    </div>
                </div>
                <!-- ./col -->
                <div class="col-6 col-6">
                    <!-- small box -->
                    <div class="small-box bg-box-blue">
                        <div class="inner">
                            <div class="mt-3 ml-3">
                                <h3 style="font-size: 40px;">{{numeroPazientiMonitorati}}</h3>

                                <p style="font-size: 20px;">Pazienti monitorati</p>
                            </div>
                        </div>
                        <div class="icon mt-1 mr-1" style="color:white !important;">
                            <i class="smartwatch">&#x0041;</i>
                        </div>
                        <!-- <div class="icon mt-1 mr-1" style="color:white !important;">
                            <i class="fas fa-users"></i>
                        </div> -->
                        <a href="javascript:void(0)" (click)="goToListPatient()"
                            class="small-box-footer small-box-footer-blue">Vai alla lista <i
                                class="fa fa-arrow-circle-right"></i></a>
                    </div>
                </div>
                <!-- ./col -->
                <!-- ./col -->
            </div>
            <!-- /.row -->
            <!-- Main row -->


            <div class="row">
                <!-- Left col -->
                <div class="col-md-2" *ngIf="!checkPermessoLetturaVisite()"></div>
                <section
                    [ngClass]="checkPermessoLetturaVisite() ? 'col-lg-6 connectedSortable p-sortable' : 'col-lg-8 connectedSortable p-sortable'">
                    <!-- Custom tabs (Charts with tabs)-->
                    <div class="card card-primary">
                        <div class="card-header bg-primary bg-primary">
                            <h3 class="card-title">Ultimi pazienti inseriti</h3>


                        </div>
                        <!-- /.card-header -->
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table m-0">
                                    <thead>
                                        <tr>
                                            <th>Identificativo</th>
                                            <th>Nome e Cognome</th>
                                            <th>Sesso</th>
                                            <th>Data di nascita</th>
                                            <th *ngIf="checkPermessoLetturaVisite()">Dettagli</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngIf="patients.length == 0">
                                            <td colspan="5">Nessun paziente inserito</td>
                                        </tr>
                                        <tr *ngFor="let patient of patients">
                                            <td>{{patient.identifier}}</td>
                                            <td>{{patient.nome}} {{patient.cognome}}</td>
                                            <td>{{patient.gender}}</td>
                                            <td>{{patient.birthDate}}</td>
                                            <td><button pButton *ngIf="checkPermessoLetturaVisite()" type="button"
                                                    (click)="goToDettagli(patient.id)" label="Visualizza"
                                                    class="p-button-primary"></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- /.table-responsive -->
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer clearfix">
                            <button pButton type="button" (click)="goToListPatient()" label="Vedi Tutti"
                                class="p-button-primary float-right"></button>
                        </div>


                        <!-- /.card-footer -->
                    </div>


                    <!-- /.card -->
                </section>
                <div class="col-md-2" *ngIf="!checkPermessoLetturaVisite()"></div>
                <section class="col-lg-6 connectedSortable" *ngIf="checkPermessoLetturaVisite()">
                    <!-- Custom tabs (Charts with tabs)-->

                    <div class="card card-primary">
                        <div class="card-header bg-primary border-transparent">
                            <h3 class="card-title">Ultime visite effettuate</h3>

                        </div>
                        <!-- /.card-header -->
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table m-0">
                                    <thead>
                                        <tr>
                                            <th>Visita</th>
                                            <th>Paziente</th>
                                            <th>Tipo</th>
                                            <th>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngIf="clinicalImpressionList.length == 0">
                                            <td colspan="5">Nessuna visita inserita</td>
                                        </tr>
                                        <tr *ngFor="let visit of clinicalImpressionList">
                                            <td> <button pButton type="button"
                                                    (click)="goToVisit(visit.id, visit.patientId)" label="Visualizza"
                                                    class="p-button-primary"></button></td>
                                            <td>{{visit.patient.__zone_symbol__value}}</td>
                                            <td><span class="badge {{visit.type}}">{{visit.descrizione}}</span>
                                            </td>
                                            <td>{{visit.date}}</td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- /.table-responsive -->
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer clearfix">
                            <button pButton type="button" (click)="goToVisits()" label="Vedi Tutte"
                                class="p-button-primary float-right"></button>
                        </div>
                        <!-- /.card-footer -->
                    </div>
                    <!-- /.card -->
                </section>

            </div>
            <div class="row" *ngIf="checkPermessoLetturaNotifiche()">
                <div class="col-md-2"></div>
                <section class="col-md-8  connectedSortable">
                    <div class="card card-primary">
                        <div class="card-header bg-primary border-transparent">
                            <h3 class="card-title">Ultimi Alert registrati</h3>

                        </div>
                        <!-- /.card-header -->
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table m-0">
                                    <thead>
                                        <tr>
                                            <th>Paziente</th>
                                            <th>Misura</th>
                                            <th>Data</th>
                                            <th>Valore</th>
                                            <th>Dettaglio</th>
                                            <th>Livello</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngIf="alertList.length == 0">
                                            <td colspan="5">Nessun alert</td>
                                        </tr>
                                        <tr *ngFor="let alert of alertList">
                                            <td>{{alert.patient.__zone_symbol__value}}</td>
                                            <td>{{alert.misura}}</td>
                                            <td>{{alert.date}}</td>
                                            <td>{{alert.value}}</td>
                                            <td>{{alert.message}}</td>
                                            <td><i style="font-size:1.5em" [ngClass]="{
                                                'text-warning':alert.level === 1,
                                                'text-danger':alert.level === 2
                                                }" class="fas fa-dot-circle"></i></td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- /.table-responsive -->
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer clearfix">
                            <button pButton type="button" (click)="goToAlerts()" label="Vedi Tutti"
                                class="p-button-primary float-right"></button>
                        </div>
                        <!-- /.card-footer -->
                    </div>
                </section>
                <div class="col-md-2"></div>
            </div>

            <!-- /.row (main row) -->

        </div>
        <!-- /.container-fluid -->

        <!-- /.content -->
    </div>
</ng-template>

<ng-template #layout2>
    <div class="row mt-1">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="pazientipresiincarico"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="pazientimonitoratiNoChart"></ng-container>
            <ng-container *ngTemplateOutlet="dropout"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="followupNoChart"></ng-container>
            <ng-container *ngTemplateOutlet="ultimevisiteNoChart"></ng-container>
            <ng-container *ngTemplateOutlet="eventi"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimeVisiteInserite"></ng-container>
        </div>
        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiPazientiInseriti"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiEventiInseriti"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #layout3>
    <!-- Stato generale -->
    <div class="row mt-1">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="presiInCaricoNoChart"></ng-container>
        </div>
        <div class="col-4">
            <ng-container *ngTemplateOutlet="cardChartPazientiPresiInCarico"></ng-container>
        </div>
        <div class="col-4">
            <ng-container *ngTemplateOutlet="dropout2"></ng-container>
            <ng-container *ngTemplateOutlet="eventi"></ng-container>
            <ng-container *ngTemplateOutlet="followupNoChart"></ng-container>
            <ng-container *ngTemplateOutlet="ultimevisiteNoChart"></ng-container>
        </div>
    </div>
    <!-- Stato pazienti monitorati -->
    <div class="row mt-1">
    </div>
</ng-template>

<ng-template #layout4>
    <div class="small-box bg-box-green p-3 height-fixed">
        <div class="row">
            <div class="col-8">
                <ng-container *ngTemplateOutlet="pazientiPresiInCaricoSideChart"></ng-container>
            </div>
            <div class="col-4">
                <ng-container *ngTemplateOutlet="followupultimevisitedropouteventiSlim"></ng-container>
            </div>
        </div>
    </div>
    <div class="small-box bg-box-green p-3 height-fixed">
        <div class="row">
            <div class="col-8">
                <ng-container *ngTemplateOutlet="pazientiMonitoratiSideChart"></ng-container>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</ng-template>

<ng-template #layout5>
    <p-divider align="center">
        <b>Dati del progetto</b>
    </p-divider>
    <div class="row">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="pazientipresiincarico"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="followupNoChart"></ng-container>
            <ng-container *ngTemplateOutlet="ultimevisiteNoChart"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="eventi"></ng-container>
            <!-- <ng-container *ngTemplateOutlet="pazientimonitoratiNoChart"></ng-container> -->
            <ng-container *ngTemplateOutlet="dropout2"></ng-container>
        </div>
    </div>

    <p-divider align="center">
        <b>Monitoraggio con soluzione digitale</b>
    </p-divider>
    <div class="row">
        <div class="col-8 offset-2">
            <div class="small-box bg-box-green p-3 height-fixed">
                <ng-container *ngTemplateOutlet="pazientiMonitoratiSideChart"></ng-container>
            </div>
        </div>
    </div>

    <p-divider align="center">
        <b>Ultime attività</b>
    </p-divider>

    <div class="row">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimeVisiteInserite"></ng-container>
        </div>
        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiPazientiInseriti"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiEventiInseriti"></ng-container>
        </div>
    </div>

</ng-template>

<ng-template #layout6>
    <p-divider align="center">
        <b>Dati del progetto</b>
    </p-divider>
    <div class="row">
        <div class="col-8">
            <div class="small-box bg-box-green p-3 height-fixed-25">
                <ng-container *ngTemplateOutlet="pazientiPresiInCaricoSideChart"></ng-container>
            </div>
        </div>

        <div class="col-4 row">
            <div class="col-6">
                <ng-container *ngTemplateOutlet="followupTile"></ng-container>
            </div>
            <div class="col-6">
                <ng-container *ngTemplateOutlet="ultimevisiteTile"></ng-container>
            </div>
            <div class="col-6">
                <ng-container *ngTemplateOutlet="eventiTile"></ng-container>
            </div>
            <div class="col-6">
                <ng-container *ngTemplateOutlet="dropout2Tile"></ng-container>
            </div>
        </div>
    </div>


    <p-divider align="center">
        <b>Monitoraggio con soluzione digitale</b>
    </p-divider>
    <div class="row">
        <div class="col-8 offset-2">
            <div class="small-box bg-box-green p-3 height-fixed">
                <ng-container *ngTemplateOutlet="pazientiMonitoratiSideChart"></ng-container>
            </div>
        </div>
    </div>

    <p-divider align="center">
        <b>Ultime attività</b>
    </p-divider>
    <div class="row">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimeVisiteInserite"></ng-container>
        </div>
        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiPazientiInseriti"></ng-container>
        </div>

        <div class="col-4">
            <ng-container *ngTemplateOutlet="tabellaUltimiEventiInseriti"></ng-container>
        </div>
    </div>

</ng-template>

<ng-template #dropout2Tile>
    <div class="small-box bg-box-green p-3" style="height: 12.1rem">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totDropout}}</h3>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-door-open"></i>
            </div>
            <div class="col-12 pt-1">
                <p style="font-size: 20px;">Dropout</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #dropout2>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totDropout}}</h3>
                <p style="font-size: 20px;">Dropout</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-door-open"></i>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientipresiincarico>
    <div class="small-box with-chart bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totPazientiPresiInCarico}}</h3>
                <p style="font-size: 20px;">Pazienti presi in carico</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-users"></i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Diabetici ipertesi</p>
                </div>
                <div class="col-6">
                    <p>{{totDiabeticiIpertesi}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Diabetici non ipertesi</p>
                </div>
                <div class="col-6">
                    <p>{{totDiabeticiNonIpertesi}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Dialitici</p>
                </div>
                <div class="col-6">
                    <p>{{totDialitici}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Pre-dialitici</p>
                </div>
                <div class="col-6">
                    <p>{{totPredialitici}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Controllo</p>
                </div>
                <div class="col-6">
                    <p>{{totControllo}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 chart-div">
                <div #chartPazientiPresiInCarico></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientipresiincarico2>
    <div class="small-box with-chart bg-box-green p-3">

        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totPazientiPresiInCarico}}</h3>
                <p style="font-size: 20px;">Pazienti presi in carico</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-users"></i>
            </div>
        </div>

        <div class="row">
            <!-- Informazioni sintetiche -->
            <div class="col-4 row">
                <div class="col-12 row card-element-row">
                    <div class="col-9">
                        <p>Diabetici ipertesi</p>
                    </div>
                    <div class="col-3">
                        <p>{{totDiabeticiIpertesi}}</p>
                    </div>
                </div>
                <div class="col-12">
                    <p-divider styleClass="custom-p-divider"></p-divider>
                </div>
                <div class="col-12 row card-element-row">
                    <div class="col-9">
                        <p>Diabetici non ipertesi</p>
                    </div>
                    <div class="col-3">
                        <p>{{totDiabeticiNonIpertesi}}</p>
                    </div>
                </div>
                <div class="col-12">
                    <p-divider styleClass="custom-p-divider"></p-divider>
                </div>
                <div class="col-12 row card-element-row">
                    <div class="col-9">
                        <p>Dialitici</p>
                    </div>
                    <div class="col-3">
                        <p>{{totDialitici}}</p>
                    </div>
                </div>
                <div class="col-12">
                    <p-divider styleClass="custom-p-divider"></p-divider>
                </div>
                <div class="col-12 row card-element-row">
                    <div class="col-9">
                        <p>Pre-dialitici</p>
                    </div>
                    <div class="col-3">
                        <p>{{totPredialitici}}</p>
                    </div>
                </div>
                <div class="col-12">
                    <p-divider styleClass="custom-p-divider"></p-divider>
                </div>
                <div class="col-12 row card-element-row">
                    <div class="col-9">
                        <p>Controllo</p>
                    </div>
                    <div class="col-3">
                        <p>{{totControllo}}</p>
                    </div>
                </div>
            </div>

            <!-- Grafico -->
            <div class="col-8 row">
                <div class="col-12  chart-div">
                    <div #chartPazientiPresiInCarico></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientimonitorati>
    <div class="small-box with-chart bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totPazientiMonitorati}}</h3>
                <p style="font-size: 20px;">Pazienti monitorati</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="smartwatch">&#x0041;</i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Diabetici ipertesi</p>
                </div>
                <div class="col-6">
                    <p>{{totDiabeticiIpertesiMonitorati}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Diabetici non ipertesi</p>
                </div>
                <div class="col-6">
                    <p>{{totDiabeticiNonIpertesiMonitorati}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Dialitici</p>
                </div>
                <div class="col-6">
                    <p>{{totDialiticiMonitorati}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Pre-dialitici</p>
                </div>
                <div class="col-6">
                    <p>{{totPredialiticiMonitorati}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 chart-div">
                <div #chartPazientiMonitorati></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #dropout>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totDropout}}</h3>
                <p style="font-size: 20px;">Dropout</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-door-open"></i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Deceduti</p>
                </div>
                <div class="col-6">
                    <p>{{totDeceduti}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Non reperibili</p>
                </div>
                <div class="col-6">
                    <p>{{totNonReperibili}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Si rifiutano di continuare</p>
                </div>
                <div class="col-6">
                    <p>{{totSiRifiutaDiContinuare}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Non specificato</p>
                </div>
                <div class="col-6">
                    <p>{{totNonSpecificato}}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #eventiTile>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totEventi}}</h3>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-book-medical"></i>
            </div>
            <div class="col-12 pt-1">
                <p style="font-size: 20px;">Eventi</p>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-9">
                    <p>Scompenso</p>
                </div>
                <div class="col-3">
                    <p>{{totEventiScompenso}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-9">
                    <p>Altri eventi</p>
                </div>
                <div class="col-3">
                    <p>{{totEventiAltro}}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #eventi>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totEventi}}</h3>
                <p style="font-size: 20px;">Eventi</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fas fa-book-medical"></i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Scompenso</p>
                </div>
                <div class="col-6">
                    <p>{{totEventiScompenso}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Eventi equivalenti</p>
                </div>
                <div class="col-6">
                    <p>{{totEventiEquivalenti}}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #tabellaUltimeVisiteInserite>
    <div class="card card-primary">
        <div class="card-header bg-button-primary-color border-transparent">
            <h3 class="card-title">Ultime visite effettuate</h3>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive">
                <table class="table m-0">
                    <thead>
                        <tr>
                            <th>Visita</th>
                            <th>Paziente</th>
                            <th>Tipo</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="clinicalImpressionList.length == 0">
                            <td colspan="5">Nessuna visita inserita</td>
                        </tr>
                        <tr *ngFor="let visit of clinicalImpressionList">
                            <td style="text-align:center"> <button pButton type="button"
                                    (click)="goToVisit(visit.id, visit.patientId)" icon="pi pi-eye" iconPos="center"
                                    class="p-button-primary"></button></td>
                            <td>{{visit.paziente}}</td>
                            <td><span class="badge {{visit.type}}">{{visit.descrizione}}</span>
                            </td>
                            <td>{{visit.date | date : 'dd/MM/YYYY'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="small-box bg-box-green p-3" *ngIf="false">
        <div class="row">
            <div class="col-12">
                <p style="font-size: 20px;">Ultime 5 visite inserite</p>
            </div>
            <div class="col-12">
                <p-table [value]="ultimeVisiteInserite" [columns]="columns_last_followups"
                    styleClass="p-datatable-striped" class="dashboard-table" selectionMode="single">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns">
                                {{col.header}}
                            </th>
                            <!-- <th></th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns">
                                <ng-container *ngIf="col.field == 'summary'">
                                    <span [innerHTML]="rowData[col.field]"></span>
                                </ng-container>
                                <ng-container
                                    *ngIf="col.field != 'summary' && col.field != 'effectiveDateTime' && col.field != 'description'">
                                    {{rowData[col.field]}}
                                </ng-container>
                                <ng-container *ngIf="col.field == 'effectiveDateTime'">
                                    {{rowData[col.field] | date : 'dd/MM/yy'}}
                                </ng-container>

                                <ng-container *ngIf="col.field == 'description'">
                                    <span class="badge {{rowData.badgeType}}">{{rowData[col.field]}}</span>
                                </ng-container>
                            </td>
                            <!-- <td style="text-align: center;"><p-button icon="pi pi-eye" iconPos="left"></p-button></td> -->
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientimonitoratiNoChart>
    <div class="small-box bg-box-green p-3">
        <ng-container *ngTemplateOutlet="pazientiMonitoratiContent"></ng-container>
    </div>
</ng-template>

<ng-template #pazientiMonitoratiContent>
    <div class="row">
        <div class="col-6">
            <h3 style="font-size: 40px;">{{totPazientiMonitorati}}</h3>
            <p style="font-size: 20px;">Pazienti monitorati</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="smartwatch">&#x0041;</i>
        </div>
        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiIpertesiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici non ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiNonIpertesiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totDialiticiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Pre-dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totPredialiticiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Controllo</p>
            </div>
            <div class="col-6">
                <p>{{totControlloMonitorati}}</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #followupNoChart>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totFollowup}}</h3>
                <p style="font-size: 20px;">Followup</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fa fa-stethoscope"></i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Previsti</p>
                </div>
                <div class="col-6">
                    <p>{{totFollowupPrevisti}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Da fare</p>
                </div>
                <div class="col-6">
                    <p>{{totFollowupMancanti}}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #followupTile>
    <div class="small-box bg-box-green p-3" style="height: 12.1rem">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totFollowup}}</h3>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fa fa-stethoscope"></i>
            </div>
            <div class="col-12">
                <p style="font-size: 20px;">Followup</p>
            </div>
            <!-- <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Previsti</p>
                </div>
                <div class="col-6">
                    <p>{{totFollowupPrevisti}}</p>
                </div>
            </div> -->
            <!-- <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div> -->

            <!-- <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Da fare</p>
                </div>
                <div class="col-6">
                    <p>{{totFollowupMancanti}}</p>
                </div>
            </div> -->
        </div>
    </div>
</ng-template>

<ng-template #ultimevisiteNoChart>
    <div class="small-box bg-box-green p-3">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totUltimeVisite}}</h3>
                <p style="font-size: 20px;">Ultime visite</p>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fa fa-stethoscope"></i>
            </div>
            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Previste</p>
                </div>
                <div class="col-6">
                    <p>{{totUltimeVisitePreviste}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Da fare</p>
                </div>
                <div class="col-6">
                    <p>{{totUltimeVisiteMancanti}}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #ultimevisiteTile>
    <div class="small-box bg-box-green p-3" style="height: 12.1rem">
        <div class="row">
            <div class="col-6">
                <h3 style="font-size: 40px;">{{totUltimeVisite}}</h3>
            </div>
            <div class="col-6" style="text-align: right;">
                <i class="fa fa-stethoscope"></i>
            </div>
            <div class="col-12">
                <p style="font-size: 20px;">Ultime visite</p>
            </div>
            <!-- <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Previste</p>
                </div>
                <div class="col-6">
                    <p>{{totUltimeVisitePreviste}}</p>
                </div>
            </div>
            <div class="col-12">
                <p-divider styleClass="custom-p-divider"></p-divider>
            </div>

            <div class="col-12 row card-element-row">
                <div class="col-6">
                    <p>Da fare</p>
                </div>
                <div class="col-6">
                    <p>{{totUltimeVisiteMancanti}}</p>
                </div>
            </div> -->
        </div>
    </div>
</ng-template>

<ng-template #tabellaUltimiPazientiInseriti>
    <div class="card card-primary">
        <div class="card-header bg-button-primary-color border-transparent">
            <h3 class="card-title">Ultimi pazienti inseriti</h3>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive">
                <table class="table m-0">
                    <thead>
                        <tr>
                            <th>Identificativo</th>
                            <!-- <th>Nome e Cognome</th> -->
                            <th>Genere</th>
                            <!-- <th>Data di nascita</th> -->
                            <th>Età</th>
                            <th>Data consenso</th>
                            <th *ngIf="checkPermessoLetturaVisite()">Dettagli</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="ultimiPazientiInseriti.length == 0">
                            <td colspan="5">Nessun paziente inserito</td>
                        </tr>
                        <tr *ngFor="let patient of ultimiPazientiInseriti">
                            <td>{{patient.patient_identifier}}</td>
                            <td>{{patient.gender}}</td>
                            <td>{{patient.age}}</td>
                            <td>{{patient.data_consenso_informato | date : 'dd/MM/YYYY'}}</td>
                            <td style="text-align:center"><button pButton *ngIf="checkPermessoLetturaVisite()"
                                    type="button" (click)="gotoAnagrafica(patient)" icon="pi pi-eye" iconPos="center"
                                    class="p-button-primary"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #tabellaUltimiEventiInseriti>
    <div class="card card-primary">
        <div class="card-header bg-button-primary-color border-transparent">
            <h3 class="card-title">Ultimi eventi inseriti</h3>
        </div>
        <div class="card-body p-0">
            <div class="table-responsive">
                <table class="table m-0">
                    <thead>
                        <tr>
                            <th>Identificativo</th>
                            <th colspan="2">Evento</th>
                            <th>Data</th>
                            <th *ngIf="checkPermessoLetturaVisite()">Eventi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="lastEvents.length == 0">
                            <td colspan="5">Nessun evento inserito</td>
                        </tr>
                        <tr *ngFor="let evento of lastEvents">
                            <td>{{evento.patient_identifier}}</td>
                            <td colspan="2">{{evento.displayEvent}}</td>
                            <td>{{evento.effectiveDate}}</td>
                            <td style="text-align:center"><button pButton *ngIf="checkPermessoLetturaVisite()"
                                    type="button" (click)="gotoTimelineVisite(evento)" icon="pi pi-eye" iconPos="center"
                                    class="p-button-primary"></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #presiInCaricoNoChart>
    <div class="small-box bg-box-green p-3 height-fixed">
        <ng-container *ngTemplateOutlet="pazientiPresiInCaricoContent"></ng-container>
    </div>
</ng-template>

<ng-template #templateChartPazientiPresiInCarico>
    <div class="chart-div" #chartPazientiPresiInCarico></div>
</ng-template>

<ng-template #cardChartPazientiPresiInCarico>
    <div class="small-box bg-box-green p-3 height-fixed">
        <div class="row">
            <div class="col-12 chart-div">
                <ng-container *ngTemplateOutlet="templateChartPazientiPresiInCarico"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientiPresiInCaricoSideChart>
    <div class="row" style="padding-top:2rem">
        <div class="col-6">
            <ng-container *ngTemplateOutlet="pazientiPresiInCaricoContent"></ng-container>
        </div>
        <div class="col-6">
            <ng-container *ngTemplateOutlet="templateChartPazientiPresiInCarico"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #pazientiPresiInCaricoContent>
    <div class="row">
        <div class="col-6">
            <h3 style="font-size: 40px;">{{totPazientiPresiInCarico}}</h3>
            <p style="font-size: 20px;">Pazienti presi in carico</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="fas fa-users"></i>
        </div>
        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiIpertesi}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici non ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiNonIpertesi}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totDialitici}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Pre-dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totPredialitici}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Controllo</p>
            </div>
            <div class="col-6">
                <p>{{totControllo}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>
    </div>
</ng-template>

<ng-template #graficoPazientiMonitorati>
    <div class="chart-div" #chartPazientiMonitorati></div>
</ng-template>

<ng-template #pazientiMonitoratiContent2>
    <div class="row">
        <div class="col-6">
            <h3 style="font-size: 40px;">{{totPazientiMonitorati}}<h4 style="display:inline">
                    /{{totPazientiPresiInCarico}}</h4>
            </h3>
            <p style="font-size: 20px;">Pazienti monitorati</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="smartwatch">&#x0041;</i>
        </div>
        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiIpertesiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Diabetici non ipertesi</p>
            </div>
            <div class="col-6">
                <p>{{totDiabeticiNonIpertesiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totDialiticiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Pre-dialitici</p>
            </div>
            <div class="col-6">
                <p>{{totPredialiticiMonitorati}}</p>
            </div>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-12 row card-element-row">
            <div class="col-6">
                <p>Controllo</p>
            </div>
            <div class="col-6">
                <p>{{totControlloMonitorati}}</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pazientiMonitoratiSideChart>
    <div class="row">
        <div class="col-6">
            <ng-container *ngTemplateOutlet="pazientiMonitoratiContent2"></ng-container>
        </div>
        <div class="col-6">
            <ng-container *ngTemplateOutlet="graficoPazientiMonitorati"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #followupultimevisitedropouteventiSlim>
    <div class="row resize-font-for-slim">
        <div class="col-6">
            <h3>{{totFollowup}}<h4>/{{totFollowupPrevisti}}</h4>
            </h3>
            <p>Followup</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="fa fa-stethoscope"></i>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-6">
            <h3>{{totUltimeVisite}}<h4>/{{totUltimeVisitePreviste}}</h4>
            </h3>
            <p>Visite conclusive</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="fa fa-stethoscope"></i>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-6">
            <h3>{{totDropout}}<h4>/{{totPazientiPresiInCarico}}</h4>
            </h3>
            <p>Dropout</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="fas fa-door-open"></i>
        </div>
        <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div>

        <div class="col-6">
            <h3>{{totEventi}}</h3>
            <p>Eventi</p>
        </div>
        <div class="col-6" style="text-align: right;">
            <i class="fas fa-book-medical"></i>
        </div>
        <!-- <div class="col-12">
            <p-divider styleClass="custom-p-divider"></p-divider>
        </div> -->

    </div>
</ng-template>